import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-staff-form-view',
  templateUrl: './staff-form-view.component.html',
  styleUrls: ['./staff-form-view.component.css']
})
export class StaffFormViewComponent implements OnInit {
  @Input() isEditMode = false;

  currentStage = 1;
  totalStages = 6;

  form = {
    fullName: 'João Silva',
    isForeigner: false,
    cpf: '123.456.789-00',
    passportNumber: '',
    rg: '12.345.678-9',
    rgIssuingAuthority: 'SSP',
    rgIssueDate: new Date(2015, 5, 12),
    birthDate: new Date(1990, 1, 15),
    gender: 'Masculino',
    maritalStatus: 'Casado(a)',
    motherName: 'Maria Silva',
    fatherName: 'Pedro Silva',
    nationality: 'Brasileira',
    birthPlace: 'São Paulo',
    hasDisability: false,
    street: 'Av. Paulista',
    number: '1000',
    neighborhood: 'Bela Vista',
    city: 'São Paulo',
    state: 'SP',
    zipCode: '01310-100',
    country: 'Brasil',
    primaryPhone: '(11) 99999-9999',
    secondaryPhone: '(11) 98888-8888',
    emergencyContactName: 'Ana',
    emergencyContactPhone: '(11) 97777-7777',
    bank: 'Banco do Brasil',
    agency: '1234-5',
    accountType: 'Corrente',
    accountNumber: '123456-7',
    registration: 'MAT-001',
    position: 'Desenvolvedor Full Stack',
    department: 'TI',
    manager: 'Carlos Almeida',
    costCenter: 'TI-01',
    hireDate: new Date(2023, 2, 15),
    terminationDate: undefined as Date | undefined,
    contractType: 'CLT',
    inactive: false,
    blocked: false,
    client: false,
    blockPeriod: undefined as Date | undefined,
    shift: 'Manhã',
    workSchedule: '08:00-17:00',
    unit: 'Matriz',
    baseSalary: 8500,
    grossSalary: 10000,
    netSalary: 8000,
    salaryCurrency: 'BRL',
    salaryType: 'Mensal',
    lastSalaryUpdate: new Date(2024, 5, 1),
    salaryNotes: 'Elegível a bônus anual',
    cnhDocumentUploaded: true,
    residenceProofUploaded: true,
    workCardUploaded: true,
    diplomaUploaded: false,
    curriculoDocumentUploaded: true
  };

  genderOptions = ['Masculino', 'Feminino', 'Não informar'];
  maritalStatusOptions = ['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)', 'União Estável'];
  contractTypeOptions = ['CLT', 'PJ', 'Temporário', 'Estagiário', 'Autônomo'];
  salaryTypeOptions = ['Mensal', 'Por Hora', 'Por Projeto', 'Comissão'];
  shiftOptions = ['Manhã', 'Tarde', 'Noite'];
  states = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];
  countries = ['Brasil','Argentina','Chile','Colômbia','México','Peru','Uruguai','Venezuela','Estados Unidos','Canadá','Reino Unido','Alemanha','França','Itália','Espanha','Portugal','Japão','China','Índia','Austrália'];

  ngOnInit(): void {}

  nextStage(): void {
    if (this.currentStage < this.totalStages) this.currentStage++;
  }

  previousStage(): void {
    if (this.currentStage > 1) this.currentStage--;
  }

  goToStage(stage: number): void {
    if (stage >= 1 && stage <= this.totalStages) this.currentStage = stage;
  }

  getStageTitle(stage: number): string {
    const titles: Record<number, string> = {
      1: 'Dados Pessoais',
      2: 'Endereço',
      3: 'Contatos',
      4: 'Dados Gerais',
      5: 'Dados Salariais',
      6: 'Documentos'
    };
    return titles[stage] || '';
  }

  getStageProgress(): number {
    return (this.currentStage / this.totalStages) * 100;
  }
}
